import React, { ReactNode } from 'react';
import * as css from './screenReader.module.scss';

const SrOnly: React.FC<React.PropsWithChildren<{ children: ReactNode }>> = ({
  children,
}) => {
  return <div className={css.screenReaderOnly}>{children}</div>;
};
export default SrOnly;
